import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=ff3ec398&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=ff3ec398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ec398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3ec398')) {
      api.createRecord('ff3ec398', component.options)
    } else {
      api.reload('ff3ec398', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=ff3ec398&scoped=true&", function () {
      api.rerender('ff3ec398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/activity.vue"
export default component.exports